import { getCsrfValue } from "../../api/ApiHelper";
import { resolveApiUrl } from "../../utils/url/urlResolver";

const apiUrl = resolveApiUrl("/wishlist/removeEntry");

export function sendData(data: { id: string; productCode: string; wishlistEntryNumber: number }) {
  return fetch(apiUrl, {
    body: JSON.stringify({
      id: data.id,
      productCode: data.productCode,
      wishlistEntryNumber: data.wishlistEntryNumber,
    }),
    method: "POST",
    cache: "no-cache",
    credentials: "same-origin", // include, omit
    mode: "cors", // no-cors, same-origin
    referrer: "no-referrer", // client
    headers: {
      "content-type": "application/json",
      CSRFToken: getCsrfValue(),
    },
  });
}
